// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info[data-v-4a7fc211]{font-style:normal;font-weight:400;font-size:16px;line-height:22px;color:var(--q4s-neutral-500);margin-top:14px;text-align:center}", ""]);
// Exports
module.exports = exports;
